import { render, staticRenderFns } from "./CookiesContent.vue?vue&type=template&id=ce26e8fc"
import script from "./CookiesContent.vue?vue&type=script&lang=ts"
export * from "./CookiesContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports